/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 13:24:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-26 11:13:41
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\filialeList.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { parseTime } from '@/utils/util'
export const searchForm = {
}

export const form = {
  line_id: undefined, // 业务线id
  set_duration: '',
  request_number: '',
  change_freq: undefined, // 更新频率
  state: 1
}

export const rules = {
  line_id: [{ required: true, message: '请选择使用平台', trigger: 'change' }],
  set_duration: [{ required: true, message: '请输入设定时长', trigger: 'change' },
{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '只能输入两位小数以内的正数' }
],
  request_number: [{ required: true, message: '请输入请求次数', trigger: 'change' }],
  popup_type: [{ required: true, message: '请选择弹窗类型', trigger: 'change' }],
}
